/* Copyright (c) 2026 Xperi. All Rights Reserved. */

export {
  AppError,
  AuthConfigServiceError,
  BindServiceError,
  ChannelsServiceError,
  DeleteDeviceBindingServiceError,
  DeviceProvisionServiceError,
  ClaimServiceError,
  DomainTokenServiceError,
  EmptyResponseError,
  ErrorTypes,
  FeProvisioningServiceError,
  ForgotPasswordServiceError,
  IDP_JWT_TOKEN_EMPTY_TOKEN_CODE,
  IdpJwtTokenServiceError,
  IpAutologinServiceError,
  MsoDefaultDeviceConfigError,
  MsoDefaultStringOverridesError,
  PartialResponseError,
  PostSignInError,
  ProfileManagementServiceError,
  TsriServiceEndpointError,
  UnauthenticatedError,
  UnauthorisedError,
  UpdatePasswordServiceError,
  ValidateEmailTokenServiceError
} from "@tivocorp/data-domain-lib";

export {
  attachHttpContext,
  getHttpContext,
  getServiceErrorCode
} from "./attachHttpContext";
export type { THttpContext } from "./attachHttpContext";
export { buildFeProvisioningServiceError } from "./buildFeProvisioningServiceError";
